module.exports = __webpack_public_path__ + "img/dot-checked.76713e54.svg";